export default "__VITE_ASSET__BWoFwisQ__"